import React, { Component } from "react";
import { connect } from "react-redux";
import StoreNav from "./store-nav.component";
import StoreService from "../services/store.service";
import ProductLabels from "./store-product-labels.component";
import { getUserGroup, isGreenTheme, showsLabels } from "../helpers/experiment";

class StoreProductDetail extends Component {
  constructor(props) {
    super(props);
    this.currentUser = props.user;
    this.state = {
      product: null,
      basketCount: 0,
      quantity: 1,
      added: false,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    const productId = this.props.match.params.id;
    StoreService.getProduct(productId)
      .then((response) => {
        this.setState({ product: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });

    this.refreshBasketCount();
  }

  refreshBasketCount() {
    StoreService.getBasket(this.currentUser.username)
      .then((response) => {
        const count = response.data.reduce((sum, item) => sum + item.quantity, 0);
        this.setState({ basketCount: count });
      })
      .catch(() => {});
  }

  changeQuantity(delta) {
    this.setState((prev) => ({ quantity: Math.max(1, prev.quantity + delta) }));
  }

  handleAddToBasket() {
    const { product, quantity } = this.state;
    StoreService.logAction(this.currentUser.username, `store-add-to-basket-${product.id}`);
    StoreService.addToBasket(this.currentUser.username, product.id, quantity)
      .then(() => {
        this.setState({ added: true });
        this.refreshBasketCount();
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  }

  render() {
    const { product, basketCount, quantity, added, loading, error } = this.state;
    const group = getUserGroup();
    const themeClassName = isGreenTheme(group) ? "store-theme-green" : undefined;

    if (loading) {
      return (
        <div id="store-page" className={themeClassName}>
          <StoreNav basketCount={basketCount} showBack={true} />
          <div className="store-content">
            <div className="store-loading">Loading...</div>
          </div>
        </div>
      );
    }

    if (error || !product) {
      return (
        <div id="store-page" className={themeClassName}>
          <StoreNav basketCount={basketCount} showBack={true} />
          <div className="store-content">
            <div className="alert alert-danger" role="alert">{error || "Product not found"}</div>
          </div>
        </div>
      );
    }

    return (
      <div id="store-page" className={themeClassName}>
        <StoreNav basketCount={basketCount} showBack={true} />
        <div className="store-content">
          <div className="store-detail">
            <img
              className="store-detail-image"
              src={`/${product.imageFilename}`}
              alt={product.name}
            />
            <div className="store-detail-info">
              <div className="store-detail-name">{product.name}</div>
              {product.labelInfo && showsLabels(group) && (
                <ProductLabels labelInfo={product.labelInfo} />
              )}
              <div className="store-detail-diet">{product.diet}</div>
              <div className="store-detail-price">£{product.price.toFixed(2)}</div>
              <div className="store-detail-calories">{product.calories}</div>
              {product.info && <div className="store-detail-allergens">{product.info}</div>}

              <div className="store-quantity-selector">
                <button type="button" onClick={() => this.changeQuantity(-1)}>-</button>
                <span>{quantity}</span>
                <button type="button" onClick={() => this.changeQuantity(1)}>+</button>
              </div>

              <div className="store-detail-actions">
                <button
                  type="button"
                  className="store-button"
                  onClick={() => this.handleAddToBasket()}
                >
                  Add to basket
                </button>

                <a
                  href="/store/basket"
                  className="store-button"
                  onClick={() => StoreService.logAction(this.currentUser.username, `store-go-to-checkout-${product.id}`)}
                >
                  Go to checkout
                </a>
              </div>
              {added && <div className="store-added-confirmation">Added to basket!</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(StoreProductDetail);
